module.exports = __webpack_public_path__ + "static/media/streak.6eb907a9.svg";